import React from 'react'
import { Mutation } from 'react-apollo'
import { gql } from 'apollo-boost'
import * as yup from 'yup'
import { Field, Formik } from 'formik'

import TemplateSelect from '../Templates/Select'
import Button from '../Button'
import Form, { Heading } from '../Form'

const CREATE_PAGE = gql`
  mutation createPage(
  $template: ID!
  ) {
    createPage(
      template: $template
    ) {
      id
    }
  }
`

const validationSchema = yup.object().shape({
  template: yup.string().required('Template is required')
})

const INITIAL_VALUES = {
  template: ''
}

const onSubmit = (values, {setSubmitting}, createPage) => {
  createPage({variables: values})
  setSubmitting(false)
}

const Create = ({onCompleted, onError}) =>
  <Mutation
    mutation={CREATE_PAGE}
    onCompleted={onCompleted}
    onError={onError}>
    {(createPage, {loading}) =>
      <Formik
        initialValues={INITIAL_VALUES}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => onSubmit(values, actions, createPage)}>
        {({isSubmitting}) =>
          <Form>
            <Heading>General</Heading>
            <Field component={TemplateSelect} name='template' label='Template' placeholder='Select a template...' required />
            <Button type='submit' fluid disabled={loading || isSubmitting}>Create New Template</Button>
          </Form>
        }
      </Formik>
    }
  </Mutation>

export default Create


// WEBPACK FOOTER //
// ./src/components/Pages/Create.js